import TextSearch from './textSearch';

import './loadMasking';

export default TextSearch.extend({
  onRender(...args) {
    TextSearch.prototype.onRender.apply(this, args);
    this.ui.$focusField.maskNumeric();
  },

  onClose() {
    this.ui.$focusField.unmask();
  }
});
